import { atom } from 'jotai';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import env from '@/env';

const rawIdentCookieAtom = atomWithSuspenseQuery(() => {
  const queryKey = ['identCookie'];

  const queryFn = async () => {
    // this true could probably be something better but we just need this check to abort doing the query
    // as we only want to query when the hudl login env is 1
    if (!Number(env.VITE_ENABLE_HUDL_LOGIN)) return true;

    const x = await fetch(`${env.VITE_HUDL_URL}/api/v2/authorizations/ident`, {
      credentials: 'include',
    });
    const result = await x.json();
    return result.ident ?? '';
  };

  return { queryFn, queryKey };
});

export const identCookieAtom = atom(async get => (await get(rawIdentCookieAtom)).data);

export const secureBucketCookieRequestedAtom = atom(false);
